import { useState, useCallback } from "react";

const useFetchBlogBySlug = () => {
  const [blog, setBlog] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchBlogBySlug = useCallback(async (slug) => {
    if (!slug) {
      setError(new Error("Slug is required"));
      return null;
    }

    setIsLoading(true);
    setIsError(false);
    setError(null);
    setBlog(null);

    try {
      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${baseUrl}/blogs/${slug}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.message || "Failed to fetch blog";
        throw new Error(message);
      }

      // Handle different response structures
      // Could be: data.data.blog, data.data, or data
      let blogData = null;
      if (data.data?.blog) {
        blogData = data.data.blog;
      } else if (data.data && typeof data.data === 'object' && !Array.isArray(data.data)) {
        blogData = data.data;
      } else if (data.blog) {
        blogData = data.blog;
      } else {
        blogData = data;
      }
      
      setBlog(blogData);
      return blogData;
    } catch (err) {
      setIsError(true);
      setError(err);
      setBlog(null);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { blog, isLoading, isError, error, fetchBlogBySlug };
};

export default useFetchBlogBySlug;

